import { Box, Grid, useMediaQuery } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  CmpButton,
  CmpSelectBox,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import { useSelector } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { GetGitterColumns } from "../../Utility/Utilitys";
import { common_EmptyBin_GETROW } from "../../Server/ApiV2";

const EmptyBinQurey = () => {
  const LocFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const [sGridrows, setGridrows] = useState([]);
  const [summaryObj, setSummaryObj] = useState({
    loc: vRdxuserLoc[0]?.UID,
  });

  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoad = () => {
    GetSummaryList();
  };

  const GetSummaryList = async () => {
    let vSummaryListObj = {
      v_Loc: summaryObj.loc == "" ? vRdxuserLoc[0]?.UID : summaryObj.loc,
    };
    const vSummaryList = await common_EmptyBin_GETROW(vSummaryListObj);
    if (vSummaryList.status == 200) {
      let GridID =
        vSummaryList.data.ResultSet.length == 0
          ? []
          : vSummaryList.data.ResultSet?.map((obj, i) => ({
              ...obj,
              id: i + 1,
            }));
      setGridrows(GridID);
    } else {
      setGridrows([]);
    }
  };

  const [Gridcolumns, setGridcolumns] = useState([
    {
      field: "binCode",
      headerName: "Bin.Code",
      hide: true,
      width: 150,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "binName",
      headerName: "Bin.Name",
      hide: false,
      width: 100,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "aisle",
      headerName: "Aisle",
      hide: false,
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "Length",
      headerName: "Length",
      hide: false,
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "Width",
      headerName: "Width",
      hide: false,
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "Height",
      headerName: "Height",
      hide: false,
      width: 90,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "CBM",
      headerName: "CBM",
      hide: false,
      width: 90,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "Level",
      headerName: "Level",
      hide: false,
      width: 90,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "Pallet",
      headerName: "Pallet",
      hide: false,
      width: 90,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "BinType",
      headerName: "Bin.Type",
      hide: false,
      width: 100,
      align: "center",
      headerAlign: "center",
    },
  ]);

  useEffect(() => {
    GetGitterColumns(setGridcolumns, "EMPTY_BIN", Gridcolumns);
    fLoad();
    LocFocusOnLoad.current?.focus();
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="">
        <CmpTypographyField
          xcomponent={"h1"}
          xText={"Empty Bin Qurey"}
          xfontSize="20px"
          xtextDecoration="underline"
        />
      </div>
      <div className="Instant-picking-head">
        <Grid
          container
          spacing={{ xs: 2, sm: 2, md: 2 }}
          className="align-items-center mt-4"
        >
          <Grid item lg={4} md={6} xs={6}>
            <CmpSelectBox
              xLabelText="Location"
              xValue={
                summaryObj.loc === "" ? vRdxuserLoc[0]?.UID : summaryObj.loc
              }
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"loc"}
              xData={vRdxuserLoc}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={3} xs={6} className="bintransfet-data-load-btn">
            <CmpButton
              xbtnName="Load"
              xOnClick={fLoad}
              xVariant="contained"
              xSize="small"
            />
          </Grid>
        </Grid>

        <Box
          sx={{ height: vMediaQuery ? "60vh" : "70vh", width: "100%" }}
          className="bin-transfer-data"
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
            }}
            rows={sGridrows}
            columns={Gridcolumns}
            // pageSize={5}
            // rowsPerPageOptions={[5]}
            hideFooter={sGridrows.length < 100}
            components={{
              Toolbar: vMediaQuery ? "" : GridToolbar,
            }}
            // onRowClick={fOnRowClick}
          />
        </Box>
      </div>
    </div>
  );
};

export default EmptyBinQurey;
